/* eslint-disable comma-dangle */

export default {
  address: ['user-input', 'map', 'underground'],
  'about-object': [
    'commercial-area-parts',
    'common/cadastral-number',
    'common/tax-number',
    'commercial-total-area',
    'can-parts',
    'commercial-area-from',
    'floor-commercial',
    'is-legal-address-provided',
    'ceiling-height',
    'column-grid',
    'floor-material-type',
    'condition-type',
    'gates_type',
    'lifts',
    'cranes',
    'common/water-pipes',
    'electricity-power',
    'parking-location',
    'parking-purpose',
    'common/parking-places-count',
    'parking-price-enter',
    'additional-services',
  ],
  'about-building': [
    'name-and-year-commercial',
    'building-type',
    'commercial-class',
    'total-area',
    'land',
    {
      name: 'visual-divider',
      hideOnMobile: true,
    },
    'building-status-type',
    'building-developer',
    'building-management-company',
    'additional-items',
  ],
  'price-and-deal-terms': ['price-multi-sale', 'vat-type', 'lease-assignment-checkbox', 'agent-bonus'],
};
